<template>
  <Modal :title="title" name="REPLACE_TERM_MODAL" persistent>
    <template v-slot:body>
      <v-alert type="warning" text>
          {{ $t('rentOut.replaceTermWarnMessage') }}
      </v-alert>

      <div>
        <div v-if="newTermName && !isAppointmentFilesUploading">
            <h6>
              {{ $t('rentOut.newTerm') }}
            </h6>

            <v-chip
              color="grey lighten-3"
              class="px-2"
              small
            >
                <span class="d-block text-truncate">
                  {{ newTermName }}
                </span>
            </v-chip>
        </div>

        <HUpload
          @change="handleGetFiles"
          :loading="isAppointmentFilesUploading || isTermUploading"
          fileTypes="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          componentId="termReplace"
          small
        />
        
        <div class="d-flex justify-end">
          <v-btn 
            @click="handleTermReplacement()" 
            :disabled="!hasTermToUpload" 
            :loading="isTermUploading"
            color="primary" 
            elevation="0" 
            large
          >
            {{ $t('appointment.label.replace') }}
          </v-btn>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import HUpload from '../../lib/HUpload.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ModalAppointmentTermReplace',

  components: {
    Modal,
    HUpload,
  },

  props: {
    isAdmin: {
      type: Boolean
    }
  },

  mounted() {
    this.reset()
  },

  data() {
    return {
      title: this.$t('rentOut.replaceTerm'),
      newTermName: null,
      filesToUpload: null,
    }
  },

  computed: {
    ...mapGetters(['appointmentFields', 'appointment', 'isAppointmentFilesUploading', 'isTermUploading']),

    hasTermToUpload() {
      return this.filesToUpload && this.filesToUpload.length > 0
    }
  },

  methods: {
    ...mapActions(['attachTerminationFile', 'replaceAppointmentTerm', 'resetAppointmentFields']),
    ...mapMutations(['setIsTermUploading']),

    handleGetFiles(files) {
      this.newTermName = files[0].name
      this.filesToUpload = files
    },

    async handleTermReplacement() {
      this.setIsTermUploading(true)
      await this.attachTerminationFile({files: this.filesToUpload, isAdmin: this.isAdmin})

      let body = {
        appointment_id: this.appointment.id,
        new_term: {
          filename: this.appointmentFields.term.filename,
          external_filename: this.appointmentFields.term.external_filename
        }
      }

      await this.replaceAppointmentTerm({ body, isAdmin: this.isAdmin })
      this.reset()
    },

    reset() {
      this.newTermName = null
      this.resetAppointmentFields()
    }
  },
}
</script>
